module.exports = __webpack_public_path__ + "static/media/user-check.d92cd35e.svg";